// App-wide snackbar host. Renders the single transient message held in the
// snackbar slice as a MUI Snackbar + Alert. Mounted once at the app root so any
// page can surface feedback via dispatch(showSnackbar(...)). Auto-hides; the
// Alert keeps its severity color while the snackbar fades out.
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, Alert } from '@mui/material';
import { hideSnackbar } from '../store/snackbar-slice.js';

const AUTO_HIDE_MS = 6000;

const SnackbarHost = () => {
  const dispatch = useDispatch();
  const { open, message, severity } = useSelector((s) => s.snackbar);

  const handleClose = (_event, reason) => {
    if (reason === 'clickaway') return;
    dispatch(hideSnackbar());
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={AUTO_HIDE_MS}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarHost;
